var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBikeIcon = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#0A3847",
  clipPath: "url(#bikeIcon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.857 4.586a.6.6 0 0 0-.367-.734l-.601-.21v-1.3l.992.367A1.805 1.805 0 0 1 6.988 4.9l-.247.89h.139a2.4 2.4 0 0 1 2.063 1.167L10.802 10l1.077-3.61h-.927V5.189h3.989l-.38 1.203h-1.4L12.1 9.94a3.91 3.91 0 1 1-1.149 2.767 3 3 0 0 1 0-.343c.337.31.754.518 1.204.602q.194.032.39.036l2.016-.03.403-1.203h-2.406a1.4 1.4 0 0 1-.229-.03 1.2 1.2 0 0 1-.668-.385 1 1 0 0 1-.132-.169l-.162-.264a4 4 0 0 0-.295.788q-.09.322-.12.655a2.3 2.3 0 0 1-.464-.547L7.945 7.594a1.2 1.2 0 0 0-1.035-.602h-.487l-.638 2.232a3.9 3.9 0 0 0-1.149-.373z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.01 8.797q.303.005.602.054l-.337 1.203c-.06.199-.86 2.978-.86 2.978h1.263l.752-2.599.343-1.203a3.898 3.898 0 1 1-1.763-.433M15.74 6.39l.404-1.202h3.032l-.403 1.203zM17.155 8.195h-2.016l.403-1.203h2.022z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "bikeIcon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M19.375.375H.125v19.25h19.25z"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBikeIcon);
export default ForwardRef;